<template>
    <BaseModal ref="modal" v-model="modalShow" size="md">
        <form @submit.prevent="onSubmit">
            <label for="nameInput">Nuevo recurso</label>
            <FileInput
                ref="input"
                id="nameInput"
                @input="onInput"
                class="form-control mb-2"
                accept=".pdf, .mp4, .avi, .mkv, .webm, .ogg, .mov"
                required
            />

            <button type="submit" class="btn btn-primary" :disabled="isUploading">
                <b-spinner v-if="isUploading" small class="me-2" />
                Añadir
            </button>
        </form>
    </BaseModal>
</template>

<script>

import { EventNames } from '@/plugins/enums/index.js'
import { mapActions } from 'vuex';
import BaseModal from '@/components/shared/Base-modal.vue';
import FileInput from '@/components/shared/File-input.vue';

export default {
    name: 'ResourceForm',

    data() {
        return {
            file: null,
            route: null,
            modalShow: false,
            isUploading: false,
            curriculumId: null,
            courseId: null,
        }
    },

    components: {
        BaseModal,
        FileInput
    },

    async mounted() {
        this.$eventBus.$on(EventNames.OpenResourceFormModal, ({ courseId, curriculumId}) => {
            this.curriculumId = curriculumId;
            this.courseId = courseId;
            this.modalShow = true;
        });
    },

    methods: {
        ...mapActions(["addCurriculumResource", "saveThemeResourceDocument"]),

        async onSubmit() {
            this.isUploading = true
            let result = await this.uploadResource()

            if (!result) {
                this.isUploading = false
                return
            }

            let resultAdd = await this.addResourceToTheme()
            if (!resultAdd) {
                this.isUploading = false
                return
            }

            this.isUploading = false
            this.reset()
            this.$refs.modal.showAlert('Recurso añadido', 'success')
            this.$eventBus.$emit(EventNames.UpdateCurrentCurriculum, { courseId: this.courseId })
        },

        async uploadResource() {
            if (this.route) {
                return true
            }

            let result = await this.saveThemeResourceDocument(this.file)

            if (result.isError) {
                this.$refs.modal.showAlertExternal(result.message, 'danger');
                return false;
            }

            this.route = result.data
            return true;
        },

        async addResourceToTheme() {
            let result = await this.addCurriculumResource({
                themeId: this.curriculumId,
                name: this.file.name,
                route: this.route
            })

            if (result.isError) {
                this.$refs.modal.showAlert(result.message, 'danger');
                return false;
            }

            return true;
        },

        reset() {
            this.file = null;
            this.router = null
            this.$refs.input.reset();
        },

        onInput(file) {
            this.file = file;
            this.route = null
        },
    }
}</script>
